import { render, staticRenderFns } from "./GetStartedSection.vue?vue&type=template&id=f134e9cc&scoped=true&"
import script from "./GetStartedSection.vue?vue&type=script&lang=js&"
export * from "./GetStartedSection.vue?vue&type=script&lang=js&"
import style0 from "./GetStartedSection.vue?vue&type=style&index=0&id=f134e9cc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f134e9cc",
  null
  
)

export default component.exports